(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.headerGroupContainer = document.getElementById('header-group');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.headerGroupContainer);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }


    this.currentScrollTop = scrollTop;
  }

 hide() {
  this.headerGroupContainer.classList.add('shopify-section-header-sticky', 'animate');
  this.closeMenuDisclosure();
}


  reveal() {
    this.headerGroupContainer.classList.add('shopify-section-header-sticky', 'animate');
  }

  reset() {
    this.headerGroupContainer.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.headerGroupContainer.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}

customElements.define('sticky-header', StickyHeader);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video-mp4"] && !Shopify.designMode) return;
  try {
    
(function() {
  const root = document.getElementById('section-{{ section.id }}');
  if (!root) return;
  const wrapper = root.querySelector('.video-wrapper');
  const bp = parseInt(wrapper.getAttribute('data-breakpoint'), 10) || 768;

  const vd = root.querySelector('video[data-role="desktop"]');
  const vm = root.querySelector('video[data-role="mobile"]');
  const mql = window.matchMedia(`(max-width:${bp}px)`);

  // Nur das aktive Video laden/abspielen
  function activate(active, inactive) {
    if (inactive) {
      try { inactive.pause(); } catch(e){}
      // Quellen entladen verhindert Preload auf manchen Browsern nicht zuverlässig,
      // deshalb belassen wir die <source>-Tags, aber kein play() & preload="none".
    }
    if (active) {
      const wantAutoplay = active.getAttribute('data-autoplay') === 'true';
      // Auf Sichtbarkeit prüfen, dann (auto)play
      if (wantAutoplay) {
        active.play().catch(()=>{ /* iOS kann blocken bis Interaktion */ });
      }
    }
  }

  function onChange() {
    if (mql.matches) { // mobil
      activate(vm || vd, vd);
    } else { // desktop
      activate(vd || vm, vm);
    }
  }

  // Autopause außerhalb des Viewports (spart Akku/Daten)
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      const video = e.target;
      if (!video) return;
      if (e.isIntersecting) {
        if (video.getAttribute('data-autoplay') === 'true') {
          video.play().catch(()=>{});
        }
      } else {
        try { video.pause(); } catch(e){}
      }
    });
  }, { threshold: 0.25 });

  [vd, vm].forEach(v => v && io.observe(v));

  mql.addEventListener ? mql.addEventListener('change', onChange) : mql.addListener(onChange);
  onChange();
})();

  } catch(e) { console.error(e); }
})();
})();
